import { Reveal } from "@/components/Motion";
import { DOMAINS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const Curriculum = () => {
  return (
    <section
      id="curriculum"
      data-testid="curriculum"
      className="relative py-28 md:py-36 bg-[#0a0a12]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#16fcfb]">
            [ 008 ] Detailed Curriculum
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display font-700 text-4xl md:text-5xl leading-[1.05] tracking-tight text-white">
            Course Curriculum & Domain Breakdown
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 font-body text-base text-white/65 leading-relaxed">
            The HCASP certification body of knowledge spans five core domains:
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            className="mt-12"
            data-testid="curriculum-accordion"
          >
            {DOMAINS.map((d, i) => (
              <AccordionItem
                key={d.n}
                value={`item-${i}`}
                className="border-b border-[#3d414f]"
                data-testid={`curriculum-domain-${d.n}`}
              >
                <AccordionTrigger className="py-6 hover:no-underline group">
                  <div className="flex items-center gap-5 text-left">
                    <span className="font-mono2 text-sm text-[#4d4479] group-hover:text-[#16fcfb] transition-colors">
                      {d.n}
                    </span>
                    <div>
                      <div className="font-display font-600 text-lg md:text-xl text-white group-data-[state=open]:text-[#16fcfb] transition-colors">
                        Domain {d.n}: {d.title}
                      </div>
                      <div className="mt-1 font-mono2 text-[11px] uppercase tracking-[0.15em] text-[#97b8ff]">
                        {d.weight} · {d.short}
                      </div>
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-8">
                  <div className="space-y-7 pl-0 md:pl-11">
                    {d.groups.map((g) => (
                      <div key={g.heading}>
                        <h4 className="font-mono2 text-sm font-500 text-[#97b8ff]">
                          {g.heading}
                        </h4>
                        <ul className="mt-3 space-y-2.5">
                          {g.items.map((it, k) => (
                            <li key={k} className="flex gap-3">
                              <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-[#16fcfb]" />
                              <span className="font-body text-sm md:text-base text-white/75 leading-relaxed">
                                {it}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default Curriculum;
